import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface Statistic {
  id: number;
  value: string;
  label: string;
  icon: string;
}

interface StatisticsPanelProps {
  statistics: Statistic[];
}

const StatisticsPanel = ({ statistics }: StatisticsPanelProps) => {
  return (
    <section className="mb-16">
      <div className="rounded-xl bg-gradient-to-br from-primary to-secondary p-8 shadow-warm-lg md:p-12">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          {statistics.map((stat) => (
            <div key={stat.id} className="text-center">
              <div className="mb-3 flex justify-center">
                <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/20">
                  <Icon
                    name={stat.icon as any}
                    size={32}
                    variant="solid"
                    className="text-primary-foreground"
                  />
                </div>
              </div>
              <div className="mb-1 font-heading text-4xl font-bold text-primary-foreground">
                {stat.value}
              </div>
              <div className="text-sm font-medium text-primary-foreground/90">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatisticsPanel;